import { render, staticRenderFns } from "./MapLegendCard.vue?vue&type=template&id=3d7ae972&scoped=true"
import script from "./MapLegendCard.vue?vue&type=script&lang=ts"
export * from "./MapLegendCard.vue?vue&type=script&lang=ts"
import style0 from "./MapLegendCard.vue?vue&type=style&index=0&id=3d7ae972&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7ae972",
  null
  
)

export default component.exports